// React
import React from "react";

// Kendo
import { Dialog } from '@progress/kendo-react-dialogs';
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Button } from "@progress/kendo-react-buttons";
import { IntlProvider, LocalizationProvider } from "@progress/kendo-react-intl";
import { Grid, GridColumn, GridNoRecords, getSelectedState } from "@progress/kendo-react-grid";

// Css
import "./deviceInfo.css";

const DeviceInfo = ({conn, deviceInfo, setDeviceInfo, cmdList}) => {

  console.log("device info: ", deviceInfo);

  const dataItem = deviceInfo.dataItem;

  // 닫기 이벤트
  const closeEvt = () => {
    setDeviceInfo(deviceInfo => {
      const item = {...deviceInfo};
      item.visible = !deviceInfo.visible;
      item.dataItem = {};
      return item;
    });
  }

  return (
    <Dialog title={'장비 이력'} onClose={closeEvt}>
      <div className="devInfoModalForm">
        <div className="devInfoDiv">
          <span className="devInfoSpan">발생 이벤트</span>          
          <DropDownList 
            className="devInfoDropDownList"         
            id="deviceInfo" 
            name="deviceInfo"
            data={cmdList}
            defaultValue={cmdList[0]}
          />
        </div>      
        <div className="devInfoGridArea">
          <LocalizationProvider language="ko-KR">
            <IntlProvider language="ko">              
              <Grid
                className="devInfoGrid"         
                // data={dataItem}  
                // data={deviceInfo.dataItem}                         
              >
                <GridColumn field="no" defaultValue={1}/>
                <GridColumn field="createDate" title="요청시간" width="120px" />
                <GridColumn field="cmdType" title="제어기능" width="120px" />
                <GridColumn field="cid" title="CID" width="120px" />
                <GridColumn field="rgnTerm" title="시/군/구" width="120px" />
                <GridColumn field="dongTermSimple" title="읍/면/동" width="120px" />
                <GridColumn field="userTerm" title="대상자" width="120px" />
                <GridColumn field="cmdStatus" title="적용여부" width="120px" />
                <GridColumn field="executeDate" title="적용시간" width="120px" />
                <GridNoRecords>데이터가 존재하지 않습니다.</GridNoRecords>
              </Grid>            
            </IntlProvider>
          </LocalizationProvider>
        </div>
      </div>                     
    </Dialog>
  );
}

export default DeviceInfo;